import { Upload } from "lucide-react";

const PhotoUploadForm = ({
  value,
  onChange,
  file,
  onFileChange,
  onSubmit,
  uploading,
  submitLabel = "Upload",
  accept = "image/*",
  showLinksFields = true,
}) => {
  const v = value || {};

  return (
    <form onSubmit={onSubmit} className="bg-white rounded-lg shadow p-6 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <input
          className="border rounded-md px-3 py-2 text-sm"
          placeholder="Caption"
          value={v.caption || ""}
          onChange={(e) => onChange("caption", e.target.value)}
        />

        <input
          className="border rounded-md px-3 py-2 text-sm"
          placeholder="Tags (comma separated)"
          value={v.tags || ""}
          onChange={(e) => onChange("tags", e.target.value)}
        />

        {showLinksFields ? (
          <>
            <input
              className="border rounded-md px-3 py-2 text-sm"
              placeholder="Inspection ID (optional)"
              value={v.inspection_id || ""}
              onChange={(e) => onChange("inspection_id", e.target.value)}
            />
            <input
              className="border rounded-md px-3 py-2 text-sm"
              placeholder="NCR ID (optional)"
              value={v.ncr_id || ""}
              onChange={(e) => onChange("ncr_id", e.target.value)}
            />
          </>
        ) : (

          <>
            <div className="hidden md:block" />
            <div className="hidden md:block" />
          </>
        )}

        <input
          className="border rounded-md px-3 py-2 text-sm md:col-span-4"
          placeholder="Description"
          value={v.description || ""}
          onChange={(e) => onChange("description", e.target.value)}
        />
      </div>

      <div className="flex items-center justify-between gap-4">
        <input
          type="file"
          accept={accept}
          onChange={(e) => onFileChange(e.target.files?.[0] || null)}
        />

        <button
          type="submit"
          disabled={uploading || !file}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-pink-600 text-white text-sm font-medium hover:bg-pink-700 disabled:opacity-60"
        >
          <Upload className="w-4 h-4" />
          {uploading ? "Uploading..." : submitLabel}
        </button>
      </div>
    </form>
  );
};

export default PhotoUploadForm;